import { Stack } from '@nautilusbio/nb-design-system/Stack';
import React from 'react';
import type { ReactNode } from 'react';

import styles from '../styles.module.css';

interface Props {
  label?: ReactNode;
  value?: ReactNode;
}

const TextRow = ({ label, value }: Props) => (
  <Stack className={styles.noWrap} fullWidth gap={4} justifyContent="space-between" orientation="horizontal">
    {label ? (
      <Stack className={styles.noWrap} fullWidth orientation="horizontal">
        {label}:&nbsp;
        {value}
      </Stack>
    ) : value ? (
      <Stack className={styles.noWrap} fullWidth orientation="horizontal">
        {value}
      </Stack>
    ) : null}
  </Stack>
);

export default TextRow;
